import { render, staticRenderFns } from "./CreateMerchantDialog.vue?vue&type=template&id=17ada638&scoped=true&"
import script from "./CreateMerchantDialog.vue?vue&type=script&lang=ts&"
export * from "./CreateMerchantDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ada638",
  null
  
)

export default component.exports